export default function Errors (error) {

    var errorsData = {
        message: "error",
        errors: {}
    };

    /*if (error.response.status) {
        errorsData.errors = error.response.data.errors;
    }*/
    /*if( error.response.hasOwnProperty('status') ) {
         switch(error.response.status) {
            case 401:
                errorsData.message = error.response.data.error.message;
            break;
            case 403:
                errorsData.message = error.response.data.message;
            break;
            case 422:
                errorsData = error.response.data;

            break;
         }
    }*/

    return errorsData;
}



// WEBPACK FOOTER //
// ./src/handlers/Errors.js